<template>
    <div id="app">
        <div v-if="acceptCookie === false" class="cookie-warning">
            <div class="grid-x grid-padding-x">
                <div class="columns small-12 medium-11">
                    <p class="text-white"><strong>Cookies:</strong> This website intends to use cookies to improve the site and your experience. By continuing to browse the site, you are agreeing to accept our use of cookies. If you do not wish to have cookies placed when using the site, you can modify your browser settings appropriately.</p>
                </div>
                <div class="columns small-12 medium-1 text-center pad-top-tiny">
                    <button v-on:click="cookieYes" class="button small">Accept</button>
                </div>
            </div>
        </div>
        <app-styles></app-styles>
        <router-view></router-view>
    </div>
</template>

<script>
import Styles from '@/components/Ztyles/Styles';

export default {
    name: 'app',
    metaInfo: {
        title: 'Customised Clothing',
        titleTemplate: '%s',
    },
    components: {
        'app-styles': Styles,
    },
    data() {
        return {
            acceptCookie: false,
        };
    },
    methods: {
        cookieYes() {
            this.acceptCookie = true;
            this.$cookies.set('acceptedCookies', 'true', 60 * 60 * 24 * 30);
        },
        checkCookie() {
            const cookieTest = this.$cookies.get('acceptedCookies');
            if (cookieTest === 'true') {
                this.acceptCookie = true;
            } else {
                this.acceptCookie = false;
            }
        },
        checkBasket() {
            this.$store.dispatch('checkBasket');
        },

    },
    beforeCreate() {
        if (!this.$store.state.idToken) {
            this.$store.dispatch('checkStoredToken');
        }
    },
    beforeMount() {
        this.checkCookie();
        this.checkBasket();
    },
};
</script>



// WEBPACK FOOTER //
// src/App.vue